import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useNavigate } from 'react-router-dom'
import AccountCreated from './AccountCreated'
import * as accountCreatedActions from 'Login/modules/accountCreated'

const AccountCreatedContainer = (props) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (!!props.error) {
      navigate('/signin', { replace: true })
    }
  },[props.error])

  const handleResend = () => {
    props.resendConfirmation(props.email)
  }

  return (
    <AccountCreated
      onResend={handleResend}
      isSending={props.isSending} />
  )
}

function mapStateToProps({ accountCreated }, props) {
  return accountCreated
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(accountCreatedActions, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountCreatedContainer)
